export default "__VITE_ASSET__BvnAA086__"